export type Subscription = {
  id: string;
  name: string;
  price: number;
  monitors: number;
  daily_emails: number;
};

export const allSubscriptions: Subscription[] = [
  { id: "10", name: "Pro 10", price: 495, monitors: 10, daily_emails: 10 },
  { id: "50", name: "Pro 50", price: 1495, monitors: 50, daily_emails: 50 },
  { id: "100", name: "Pro 100", price: 2495, monitors: 100, daily_emails: 100 },
  { id: "200", name: "Pro 200", price: 4995, monitors: 200, daily_emails: 200 },
  { id: "500", name: "Pro 500", price: 9995, monitors: 500, daily_emails: 500 },
  {
    id: "1000",
    name: "Pro 1000",
    price: 19995,
    monitors: 1000,
    daily_emails: 1000,
  },
];

export function subscriptionPlan(planId: string): Subscription {
  const planMonitors = planId.split("-")[0];
  const subscription = allSubscriptions.find((s) => s.id === planMonitors);
  return subscription || allSubscriptions[0];
}

export function planName(planId: string): string {
  return `Pro (${planId.split("-")[0]} monitors)`;
}

type StripeSubscriptionInfo = {
  status: string;
  current_period_end?: number | null;
  trial_end?: number | null;
};

type AccountInfo = {
  current_plan: string;
  subscription?: StripeSubscriptionInfo | null;
};

export type SubscriptionState =
  | { status: "active" }
  | { status: "trialing"; daysRemaining: number; trialEnd: Date }
  | { status: "expired" }
  | { status: "past_due" }
  | { status: "unpaid" };

export function getSubscriptionState(account: AccountInfo | null | undefined): SubscriptionState {
  if (!account?.subscription) {
    return { status: "active" };
  }

  const { status, trial_end, current_period_end } = account.subscription;

  if (status === "active") {
    return { status: "active" };
  }

  if (status === "trialing" && trial_end) {
    const trialEnd = new Date(trial_end * 1000);
    const now = new Date();
    const daysRemaining = Math.max(0, Math.ceil((trialEnd.getTime() - now.getTime()) / 86400000));
    return { status: "trialing", daysRemaining, trialEnd };
  }

  if (status === "past_due" || status === "unpaid") {
    if (trial_end && current_period_end && current_period_end <= trial_end) {
      return { status: "expired" };
    }
    return status === "unpaid" ? { status: "unpaid" } : { status: "past_due" };
  }

  return { status: "active" };
}

export function isSubscriptionBlocked(account: AccountInfo | null | undefined): boolean {
  return getSubscriptionState(account).status === "expired";
}
